export type GetBalanceResponseTypes = {
  balance: number;
  ledgerBalance: number;
  creditLimit: number;
  cashout?: {
    enabled: boolean;
    notice: string;
    dailyLimit?: number;
  };
};
export const GetBalanceMutationKey = "Get-Balance";
